/**
 * Converts a hex color string to rgba.
 * @example hexToRgba('#3b82f6', 0.9) -> 'rgba(59,130,246,0.9)'
 */
export function hexToRgba(hex: string, alpha: number): string {
  const h = hex.replace('#', '');
  const r = parseInt(h.substring(0, 2), 16);
  const g = parseInt(h.substring(2, 4), 16);
  const b = parseInt(h.substring(4, 6), 16);
  return `rgba(${r},${g},${b},${alpha})`;
}
